/**
 * L7 codex (ทะเบียนสัตว์ร้าย): counts the player's kills per family (`observe` of the 'reward' event), pays each tier
 * (10 / 50 / 200) once, and answers `mul(target)`: the permanent damage bonus against that target's family.
 * State is on the progress (`codex`, optional). No randomness.
 */
import { CODEX_FAMILIES, CODEX_TIERS, codexFamilyOf } from '../data/codex';
import { getMonster } from '../data/monsters';
import type { Entity, WorldEvent } from '../world';
import type { SystemHost, WorldSystem } from './types';

export class CodexSystem implements WorldSystem {
  readonly name = 'codex';
  constructor(private readonly h: SystemHost) {}

  private state() {
    const p = this.h.world.progress;
    return (p.codex ??= { n: {}, tier: {} });
  }

  count(fam: string): number {
    return this.h.world.progress.codex?.n[fam] ?? 0;
  }
  tier(fam: string): number {
    return this.h.world.progress.codex?.tier[fam] ?? 0;
  }

  /** Damage multiplier against `tgt` from the paid tiers of its family (1 when none). */
  mul(tgt: Entity): number {
    if (tgt.kind !== 'monster' || !tgt.brain) return 1;
    const fam = codexFamilyOf(tgt.brain.defId);
    if (!fam) return 1;
    const t = this.tier(fam);
    return t > 0 ? 1 + CODEX_TIERS[t - 1].dmg : 1;
  }

  observe(e: WorldEvent): void {
    if (e.type !== 'reward') return;
    const w = this.h.world;
    const m = w.entities.get(e.id);
    if (!m || m.kind !== 'monster' || !m.brain) return;
    const fam = codexFamilyOf(m.brain.defId);
    if (!fam) return;
    const st = this.state();
    const n = (st.n[fam] = (st.n[fam] ?? 0) + 1);
    let t = st.tier[fam] ?? 0;
    while (t < CODEX_TIERS.length && n >= CODEX_TIERS[t].kills) {
      const tier = CODEX_TIERS[t++];
      w.progress.gold += tier.silver;
      const name = CODEX_FAMILIES.find((f) => f.id === fam)?.name ?? getMonster(m.brain.defId).name;
      this.h.log('sys', `ทะเบียนสัตว์ร้าย: ปราบ${name}ครบ ${tier.kills} ตัว · ดาเมจต่อ${name} +${Math.round(tier.dmg * 100)}% และได้ ${tier.silver} ตำลึง`);
    }
    st.tier[fam] = t;
  }
}
